// Existing GallerySettings field is milliseconds; the setup input is seconds.
export function normalizePrintDelayMs(value) {
  if (value === null || value === undefined || value === '') return 5000;
  const delay = Number(value);
  return Number.isFinite(delay) && delay >= 0 ? delay : 5000;
}
